<script lang="ts">
  import useFilter from '../hooks/use-filter'

  const { filterDescription } = useFilter()
</script>

<div class="rounded-sm border border-gray-200 bg-white px-4 py-2 text-center">
  {filterDescription}
</div>
